import { useEffect } from "react";
import { useRouter } from "next/router";
import Cookies from "js-cookie";

const CheckoutRedirect = () => {
  const router = useRouter();
  const locale = router?.locale || "fr";

  useEffect(() => {
    let newCheckoutUrl;
    const hostName = window.location.hostname;
    const abTestValue = Cookies.get("ab_test_group");
    const isExperiment = abTestValue === "experiment";

    if (hostName === "localhost") {
      newCheckoutUrl = "http://localhost:3001";
    } else if (hostName.includes("staging")) {
      newCheckoutUrl = `https://c-staging.benebono.${locale}`;
    } else {
      newCheckoutUrl = `https://c.benebono.${locale}`;
    }

    const slug = isExperiment
      ? "checkout_Q3_2026"
      : "late_email_checkout_06_2025";

    window.location.replace(`${newCheckoutUrl}?slug=${slug}`);
  }, [locale]);

  return null;
};

export default CheckoutRedirect;
